<script setup>
import { onMounted, computed, ref } from "vue";
import { useRoute } from "vue-router";
import { useGlobalStore } from "@stores/global.js";

import axios from "axios";
import Purchase from "@/sections/product/Purchase.vue";
import SimilarProducts from "@/sections/product/SimilarProducts.vue";
import Faqs from "@/sections/product/Faqs.vue";

const global = useGlobalStore();
const route = useRoute();

const product = ref(null);
const loading = ref(true);
const error = ref(null);

function getProduct() {
	loading.value = true;
	product.value = {};
	axios
		.get(`/api/shopify/product/${route.params.slug}`)
		.then((p) => {
			product.value = p.data;

			if (product.value.theme) {
				global.setTheme(
					product.value.theme.background,
					product.value.theme.accent,
					product.value.theme.surface,
				);
			} else {
				console.log(`Product "${product.value.title}" has no theme set.`);
			}

			loading.value = false;
		})
		.catch((e) => {
			console.log(e);
		});
}

getProduct();
</script>

<template>
	<div class="pt-32 text-[var(--theme-surface)]">
		<div v-if="loading" class="container py-120">
			<p>Loading...</p>
		</div>
		<div v-else>
			<Purchase :product="product" />
			<SimilarProducts
				:related_products="product.related_products"
				:parent_collection="product.parent_collection"
			/>
			<Faqs :faqs="product.faqs" />
		</div>
	</div>
</template>
